// PilastersDialog.tsx — Pilasters / panel leg features (plvar + llvar)

import DialogBase from './DialogBase';
import { SlotEditor } from './SlotEditor';
import { usePendingSlot } from './usePendingSlot';
import { useShallowStore } from '../store/useStore';
import type { PlData } from '../types/panelvar';

const FIELDS = [
  { key: 'mark',       label: 'Mark',       type: 'text'   as const },
  { key: 'side',       label: 'Side',       type: 'text'   as const },
  { key: 'width',      label: 'Width',      type: 'number' as const, unit: '"', min: 0 },
  { key: 'projection', label: 'Projection', type: 'number' as const, unit: '"', min: 0 },
  { key: 'height',     label: 'Height',     type: 'number' as const, unit: '"', min: 0 },
];

export default function PilastersDialog() {
  const { ui, project, updatePanel } = useShallowStore(s => ({
    ui: s.ui, project: s.project, updatePanel: s.updatePanel,
  }));
  const panel = project?.panels.find(p => p.id === ui.activePanelId);
  const [slots, setSlots] = usePendingSlot<PlData>('plvar', panel?.plvar ?? [],
    (_px, _py, mark) => ({ mark }),
    { mark: '', side: 'left', width: 0, projection: 0, height: 0 });
  if (!panel) return null;

  return (
    <DialogBase title="Pilasters (2 max)" onOk={() => updatePanel(panel.id, { plvar: slots })}>
      <SlotEditor<PlData>
        slots={slots}
        fields={FIELDS}
        maxSlots={2}
        onChange={v => setSlots(v)}
        defaultData={() => ({ mark: '', side: 'left', width: 0, projection: 0, height: 0 })}
        label="Pilaster"
      />
    </DialogBase>
  );
}

